<template>
    <div style="width: 1082px;page-break-before: always !important; break-before: page !important;">
        <table :style="[css.workOrderTable]" style="width:100%;">
            <!-- MAX cols 15 per row -->
            <tbody>
            <tr :style="[css.tr]">
                <td colspan="15" :style="[css.td, css.text14]">
                    POPCORNI TOOTMINE SEIRELEHT
                </td>
            </tr>
            <tr :style="[css.tr]">
                <td :colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Tootmistellimuse nr</td>
                <td :colspan="2" :style="[css.td, css.paddingBig, css.colorPurple]">
                    {{ workOrder.production_order_number || "-" }}
                </td>
                <td :colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Planeeritud kogus kg</td>
                <td :colspan="2" :style="[css.td, css.paddingBig, css.colorPurple]">
                    {{ workOrder.planned_quantity_secondary || "-" }}
                </td>
            </tr>

            <tr :style="[css.tr]">
                <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Toote kood</td>
                <td :style="[css.td, css.paddingBig, css.colorPurple]">
                    {{ workOrder.product_code || "-" }}
                </td>

                <td :style="[css.td, css.paddingBig, css.colorGray]" colspan="2">Toote nimi</td>
                <td :style="[css.td, css.paddingBig, css.colorPurple]" colspan="7">
                    {{ getName(workOrder.product_name) || "-" }}
                </td>

                <td :style="[css.td, css.paddingBig, css.colorGray]">Toote EAN</td>
                <td colspan="3" :style="[css.td, css.paddingBig, css.colorPurple]">
                    {{ workOrder.product_ean || "-" }}
                </td>
            </tr>


            <tr :style="[css.tr]">
                <td :class="[css.td]" colspan="15"></td>
            </tr>


            <tr :style="[css.tr]">
                <td colspan="3" :style="[css.td, css.paddingBig, css.colorGray, css.text14]">
                    Vastutava operaatori NIMI
                </td>
                <td colspan="5" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
                <td colspan="3" :style="[css.td, css.paddingBig, css.colorGray, css.text14]">
                    Vastutava operaatori ALLKIRI
                </td>
                <td colspan="4" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
            </tr>


            <tr :style="[css.tr]">
                <td colspan="7" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                    Kinnitan "X", et liinilt on eemaldatud eelmise toote tootmiseks kulunud toorained:
                </td>
                <td colspan="1" :style="[css.td, css.paddingBig, css.colorBlue]"></td>

                <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                    Märkused:
                </td>
                <td colspan="6" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="7" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                    Kinnitan "X", et töökoht, seadme osad ja tarvikud on ENNE TOOTMIST ilma nähtavate vigastusteta ja
                    puhtad:
                </td>
                <td colspan="1" :style="[css.td, css.paddingBig, css.colorBlue]"></td>

                <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                    Märkused:
                </td>
                <td colspan="6" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="7" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                    Kinnitan "X", et töökoht, seadme osad ja tarvikud on PEALE TOOTMIST ilma nähtavate vigastusteta ja
                    puhtad:
                </td>
                <td colspan="1" :style="[css.td, css.paddingBig, css.colorBlue]"></td>

                <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray, css.textSmall]">
                    Märkused:
                </td>
                <td colspan="6" :style="[css.td, css.paddingBig, css.colorBlue]"></td>
            </tr>

            <tr :style="[css.tr]" style="height: 4px !important;">
                <td
                        colspan="15"
                        :style="[css.noBorderTopBottom, css.textExtraSmall]"
                        style="height: 4px !important;"
                ></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="15" :style="[css.td, css.paddingSmall, css.colorGray]">
                    SEIRE (tootmise alustamisel / peale seisakut)
                </td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">
                    Teostamise kellaaeg
                </td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">
                    Maitseaine pealeandmise näit
                </td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.paddingSmall, css.colorGray]">
                    Maitseaine kogus 60s
                </td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="15"
                    :style="[css.td, css.paddingSmall, css.colorGray]">
                    SEIRE (tootmise alustamisel, peale seisakut ja 1x tunnis tootmise ajal)
                </td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Teostamise kellaaeg</td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.colorGray,  css.paddingSmall]">Ahju temperatuur, (°C)</td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.colorGray,  css.paddingSmall]">Trumli pöörlemiskiirus</td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Õli pealeandmise näit</td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Toote maitse/tekstuur (+/-)</td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td colspan="2" :style="[css.td, css.colorGray, css.paddingSmall]">Pooltoote mahukaal (g/L)</td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
                <td :style="[css.td, css.colorBlue, css.paddingSmall]"></td>
            </tr>

            <tr :style="[css.tr]">
                <td :colspan="15" :style="[css.td , css.paddingBig, css.text14]">
                    Kui kontrollitud temperatuur erineb tegelikust temperatuurist üle 10 °C, teavita koheselt
                    vahetusevanemat!
                </td>
            </tr>


            <tr :style="[css.tr]" style="height: 4px !important;">
                <td colspan="15" :style="[css.noBorderTopBottom]" style="height: 4px !important;"></td>
            </tr>

            </tbody>
        </table>
        <table :style="[css.workOrderTable]" style="margin-top: 4px;width:100%;">
            <tbody>
            <tr :style="[css.tr]">
                <td :style="[css.td, css.colorGray, css.width100]" rowspan="7">Jäätmed</td>
                <td :style="[css.td, css.colorGray, css.textLeft]">Põhjus</td>
                <td :style="[css.td, css.colorGray]" colspan="4">Kogus (kg)</td>
                <td :style="[css.minWidth20]"></td>
                <td :style="[css.td, css.colorGray, css.width100]" rowspan="7">
                    Seisakute ja Rikete põhjused
                </td>
                <td :style="[css.td, css.colorGray]">Min</td>
                <td :style="[css.td, css.colorGray]" colspan="6">
                    Märkused (Toote kvaliteedi puudus, tooraine puudus, tehniline rike, muu seisak):
                </td>
            </tr>
            <tr :style="[css.tr]" v-for="(row_nr, index) in maxWasteAndDowntimeRowsCount">
                <td :style="[css.td, css.textLeft, css.colorYellow]">
                    {{ workOrder.wastes_secondary[index] ? workOrder.wastes_secondary[index].reason : "" }}
                </td>
                <td colspan="4" :style="[css.td, css.textLeft, css.colorYellow]">
                    {{ workOrder.wastes_secondary[index] ? workOrder.wastes_secondary[index].quantity : "" }}
                </td>
                <td></td>
                <td :style="[css.td, css.colorGray, css.colorYellow]">
                    {{
                        workOrder.downtimes_and_breakdowns_secondary[index]
                                ? workOrder.downtimes_and_breakdowns_secondary[index].time_in_minutes
                                : ""
                    }}
                </td>
                <td colspan="6" :style="[css.td, css.colorGray, css.colorYellow]">
                    {{
                        workOrder.downtimes_and_breakdowns_secondary[index]
                                ? workOrder.downtimes_and_breakdowns_secondary[index].notes
                                : ""
                    }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { helperMixin } from "../../../../mixins/helper-mixin";

export default {
    name: "toaster-2-polaris-3-popcorn-page",
    mixins: [helperMixin],
    props: {
        workOrder: Object,
        css: Object,
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters("WorkOrderStore", ["isToasterLineNumber"]),
        maxWasteAndDowntimeRowsCount() {
            let maxValue = 6;
            if (this.isToasterLineNumber) maxValue = 5
            return Math.max(this.workOrder.wastes_secondary.length, this.workOrder.downtimes_and_breakdowns_secondary.length, maxValue);
        }
    },
    methods: {}
};
</script>

<style scoped lang="scss"></style>